import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type BadgeVariant = 'success';

/**
 * The small pill badge - originally the navbar's "RE" marker next to the AI menu item
 * (`app-navbar__badge`, styled with `$success-color`/`$success-color-15`) - extracted into one
 * shared component so every AI-provenance marker (currently: Market Context) uses the exact same
 * visual language instead of a copy of the CSS per caller.
 *
 * Presentational only: it does not translate its own content. Callers MUST pass content that is
 * ALREADY TRANSLATED (run it through the `translate` pipe/service yourself before projecting it -
 * never a hardcoded literal, English or otherwise), exactly like the navbar's
 * `{{ badge.text | translate }}` did before the extraction - this is a refactor of where the
 * style lives, not a behaviour change for the navbar, and not an exemption from i18n.
 */
@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  host: {
    class: 'app-badge-host',
  },
})
export class BadgeComponent {
  @Input() public variant: BadgeVariant = 'success';
}
